import PropTypes from 'prop-types';

const MobileIcon = ({ color, className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.28571 0.75H19.7143C19.8724 0.75 20.0146 0.809114 20.1117 0.899763C20.2071 0.98878 20.25 1.098 20.25 1.2V22.8C20.25 22.902 20.2071 23.0112 20.1117 23.1002C20.0146 23.1909 19.8724 23.25 19.7143 23.25H4.28571C4.12758 23.25 3.98544 23.1909 3.88832 23.1002C3.79294 23.0112 3.75 22.902 3.75 22.8V1.2C3.75 1.098 3.79294 0.988782 3.88832 0.899763C3.98544 0.809113 4.12758 0.75 4.28571 0.75Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <circle cx="12" cy="19" r="1.25" stroke={color} strokeWidth="1.5" />
  </svg>
);

MobileIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
};

MobileIcon.defaultProps = {
  color: '#0D0D0D',
  className: ''
};

export default MobileIcon;
